import { html } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { encodeHtmlEntities } from '@mfe/util/helpers';
import { ConsentType } from '@mfe/types/common';
import featureDef from '@mfe/defs/features';
import { doToggle } from '../util';

export const featuresTemplate = (consent: ConsentType, disabled: boolean, id: string) => {
  const existedFeatures = featureDef.filter((feature) => consent[feature]);
  return html`
      ${existedFeatures /* eslint-disable indent, @typescript-eslint/indent */
        .map((feature) => consent[feature].map(({
           id: fid, granted, title, description,
          }) => {
          const featureLabel = (
            description === title
              ? title
              : `<div>
                <abbr title="${encodeHtmlEntities(description)}">
                  ${title}
                </abbr>
              </div>`);
          const checkboxId = `${id}_${feature}_${fid}`;
          if (disabled) {
            return html`
            <one-list icon="${consent.granted ? 'check' : 'cancel'}" size="lg">
              <one-list-item>
                <one-icon name="${granted ? 'check' : 'cancel'}" variant="outline" slot="icon">
                </one-icon>
                <one-content>
                    ${unsafeHTML(featureLabel)}
                </one-content>
              </one-list-item>
            </one-list>
            `;
          }
          return html`
              <one-cluster gap="xxs" no-wrap>
                <one-checkbox
                  id=${checkboxId}
                  name=${checkboxId}
                  type="checkbox"
                  .checked=${granted}
                  @change=${doToggle({
                    id,
                    fid,
                    feature,
                  })}
                  variant="outline"
                ></one-checkbox>
                <one-content>
                    ${unsafeHTML(featureLabel)}
                </one-content>
              </one-cluster>
            `;
        }))
      /* eslint-enable indent, @typescript-eslint/indent */}
    `;
};
export default featuresTemplate;
